<div class="profile-field-dialog-container">
  <div class="title-row dialog-row">
    <h2>{{ isCreate ? ("people.profileFields.titleCreate" | translate) : ("people.profileFields.titleEdit" | translate) }}</h2>
  </div>
  <div class="dialog-row dialog-content">
    <mat-form-field class="text-field key-field" appearance="outline">
      <mat-label>{{ "people.profileFields.placeholderKey" | translate }}</mat-label>
      <input
        [disabled]="!isCreate"
        matInput
        type="text"
        [(ngModel)]="dataProfileField.mapTo"
        (ngModelChange)="validateValue($event, 'keyError')"
        placeholder="{{ 'people.profileFields.placeholderKey' | translate }}" />
      @if (error.keyError) {
        <mat-hint class="error">* {{ error.keyError | translate }}</mat-hint>
      }
      @if (!error.keyError) {
        <mat-hint>
          {{ "people.profileFields.hint.alphanumCharacters" | translate }}
        </mat-hint>
      }
    </mat-form-field>

    <mat-form-field class="text-field name-field" appearance="outline">
      <mat-label>{{ "people.profileFields.placeholderDisplayName" | translate }}</mat-label>
      <input
        matInput
        type="text"
        [(ngModel)]="dataProfileField.name"
        (ngModelChange)="validateValue($event, 'nameError')"
        placeholder="{{ 'people.profileFields.placeholderDisplayName' | translate }}" />
      @if (error.nameError) {
        <mat-hint class="error">* {{ error.nameError | translate }}</mat-hint>
      }
    </mat-form-field>
    <div class="hint" [innerHTML]="hintText"></div>
  </div>

  <div class="actions-row dialog-row">
    <div class="spacer"></div>
    <button mat-stroked-button class="secondary-button" (click)="closeDialog()">{{ "generic.close" | translate | uppercase }}</button>
    @if (!isCreate) {
      <button mat-stroked-button disabled="{{ error.nameError.length ? true : false }}" class="primary-button" (click)="updateValue()">
        <span>{{ "generic.save" | translate | uppercase }}</span>
      </button>
    }
    @if (isCreate) {
      <button mat-stroked-button disabled="{{ error.nameError.length || error.keyError.length ? true : false }}" class="primary-button" (click)="createValue()">
        <span>{{ "generic.create" | translate | uppercase }}</span>
      </button>
    }
  </div>
</div>
